import { asDate } from "./as-date";
import { dateRangeFactory, dateRangeUtils } from "./date-range";
import type { IsoAndUnixTimestamp } from "./iso-and-unix";
import { startOfDayZoned } from "./start-and-end-of-day-zoned";
import type { Timezone } from "./timezone";
import { tz } from "./timezone";

// TODO: Expects both dates to be in the same timezone
// TODO: Which might not always be the case
function isSameDayInTimezone(
    date1: Date,
    date2: Date,
    timezone?: Timezone,
): boolean;
function isSameDayInTimezone(
    date1: IsoAndUnixTimestamp,
    date2: IsoAndUnixTimestamp,
    timezone?: Timezone,
): boolean;
function isSameDayInTimezone(
    date1: Date | IsoAndUnixTimestamp,
    date2: Date | IsoAndUnixTimestamp,
    timezone = tz.EuropeStockholm,
): boolean {
    const firstDate = asDate(date1);
    const secondDate = asDate(date2);
    const start =
        firstDate.getTime() < secondDate.getTime() ? firstDate : secondDate;
    const end =
        firstDate.getTime() < secondDate.getTime() ? secondDate : firstDate;
    const dateRange = dateRangeFactory.from({
        start,
        end,
        timezone,
    });
    return dateRangeUtils.isOnlyOneDate(dateRange);
}
function isSameYearInTimezone(
    date1: Date,
    date2: Date,
    timezone?: Timezone,
): boolean;
function isSameYearInTimezone(
    date1: IsoAndUnixTimestamp,
    date2: IsoAndUnixTimestamp,
    timezone?: Timezone,
): boolean;
function isSameYearInTimezone(
    date1: Date | IsoAndUnixTimestamp,
    date2: Date | IsoAndUnixTimestamp,
    timezone = tz.EuropeStockholm,
): boolean {
    const _date1 = startOfDayZoned(asDate(date1), timezone);
    const _date2 = startOfDayZoned(asDate(date2), timezone);
    return _date1.getFullYear() === _date2.getFullYear();
}

function isTodayInTimezone(date1: Date, timezone?: Timezone): boolean;
function isTodayInTimezone(
    date1: IsoAndUnixTimestamp,
    timezone?: Timezone,
): boolean;
function isTodayInTimezone(
    date1: Date | IsoAndUnixTimestamp,
    timezone = tz.EuropeStockholm,
): boolean {
    return isSameDayInTimezone(asDate(date1), new Date(), timezone);
}

export { isSameDayInTimezone, isSameYearInTimezone, isTodayInTimezone };
